'use client';

import { c as _c } from "react/compiler-runtime";
import { type OptionTabGroup, TabGroup } from '@morpho-org/ui-v6/client';
import { useQueryState } from 'nuqs';
import { memo } from 'react';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary/SectionErrorBoundary';
import SubTabsStickyBackground from '@/components/common/SubTabsStickyBackground';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
import { DashboardActivity } from './DashboardActivity';
import DashboardIdentityCard from './DashboardIdentityCard';
import DashboardPageLayout from './DashboardPageLayout';
import DashboardPositions from './DashboardPositions';
import DashboardRewardButton from './DashboardRewardButton';
export type DashboardTabs = 'positions' | 'activity';
const DashboardPage = () => {
  const $ = _c(30);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      defaultValue: "positions",
      parse: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [activeTab, setActiveTab] = useQueryState("tab", t0);
  const {
    isSelf
  } = useViewedAccountAddress();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "Positions",
      value: "positions"
    }, {
      label: "Activity",
      value: "activity"
    }];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tabOptions = t1;
  let t2;
  if ($[2] !== activeTab) {
    t2 = tabOptions.some(option => option.value === activeTab) ? activeTab : "positions";
    $[2] = activeTab;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const effectiveActiveTab = t2;
  let t3;
  if ($[4] !== setActiveTab) {
    t3 = value_0 => {
      const targetOption = tabOptions.find(option_0 => option_0.value === value_0);
      if (targetOption?.isDisabled) {
        return;
      }
      setActiveTab(value_0);
    };
    $[4] = setActiveTab;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleTabChange = t3;
  let t4;
  if ($[6] !== isSelf) {
    t4 = isSelf ? <SectionErrorBoundary fallback={null} section="DashboardRewardButton" route="/portfolio"><DashboardRewardButton /></SectionErrorBoundary> : null;
    $[6] = isSelf;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const rewardButton = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DashboardIdentityCard />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== rewardButton) {
    t6 = rewardButton && <div className="flex empty:hidden lg:hidden">{rewardButton}</div>;
    $[9] = rewardButton;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div className="gap-sm flex flex-col lg:contents">{t5}{t6}</div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== rewardButton) {
    t8 = rewardButton ? <div className="max-lg:hidden">{rewardButton}</div> : undefined;
    $[13] = rewardButton;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== effectiveActiveTab || $[16] !== handleTabChange || $[17] !== t8) {
    t9 = <SubTabsStickyBackground data-testid="dashboard-tabs" topPosition={1} zIndexLevel="higher"><TabGroup id="dashboard-tabs" options={tabOptions} value={effectiveActiveTab} onChange={handleTabChange} hasActiveBorder={true} mobileVariant="expanded" rightElement={t8} /></SubTabsStickyBackground>;
    $[15] = effectiveActiveTab;
    $[16] = handleTabChange;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== effectiveActiveTab) {
    t10 = effectiveActiveTab === "positions" && <DashboardPositions />;
    $[19] = effectiveActiveTab;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== effectiveActiveTab) {
    t11 = effectiveActiveTab === "activity" && <DashboardActivity />;
    $[21] = effectiveActiveTab;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="flex flex-col gap-12">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t7 || $[28] !== t9) {
    t13 = <DashboardPageLayout>{t7}{t9}{t12}</DashboardPageLayout>;
    $[26] = t12;
    $[27] = t7;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
export default memo(DashboardPage);
function _temp(value) {
  return value as DashboardTabs;
}